import config from '../config';

export type AdminLocale = 'en' | 'ru';

export function getAdminLocale(): AdminLocale {
    try {
        const hostname = new URL(config.api.baseUrl).hostname;
        return hostname === 'seemeworking.com' ? 'en' : 'ru';
    } catch {
        return 'ru';
    }
}
